import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";
import Alert from "@util/alert.js";
import ViewTool from "./viewTool.js";

export default class GroupView{
    constructor(model){
        this._el = null;
        this._model = model;

        this._model._view = this;

        this._headerBoxEl = null;
        this._mainSkuBoxEl = null;

        this._addEl = null;
        this._reduceEl = null;
    }

    getPackageReduceBtnDisabled(){
        if(this._model._groupCount == 1){
            return "disabled";
        }
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }

    getPackageAddBtnDisabled(){
        if (this._model._groupCount >= this._model.getMaxBuyCount()) {
            return "disabled";
        }
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }
    getPackageNumBtnDisabled(){
        if(this._model._purchaseEnable == false){
            return "disabled";
        }
        return "";
    }

    getPackageCheckbox(){
        //失效商品
        if(this._model._invalid){
            return '';
        }
        if(this._model._purchaseEnable == false){
            return `<i class="iconfont icon-disabled item_checkbox"></i>`; 
        }
        if(this._model._isChecked){
            return `<i tag='setActive' class="iconfont icon-checked item_checkbox"></i>`;
        }else{
            return `<i tag='setActive' class="iconfont icon-uncheck item_checkbox"></i>`;
        }
    }

    getPackageCountBtn(){
        let html = '';
        if(this._model._invalid){
            // html = `<div class="fl le_width_172 i_quantity"><span tag='mainsku_count'>${this._model._groupCount}</span></div>`;
            html = "";
        }else{
            html = `<input type='button' ${this.getPackageReduceBtnDisabled()} value='-' class='reduce' tag='packagereduce'>
            <input class='num'  ${this.getPackageNumBtnDisabled()} tag='tcCount' value='${this._model._groupCount}' type='text'>
            <input type='button' ${this.getPackageAddBtnDisabled()} value='+' class='add' tag='packageadd'>`;
        }
        return html;
    }
    // 渲染时候有预售。候补销售等头部
    getHeader(){
        let html = "";
        //单品，选件
        if(this._model._itemType == Constant.GROUP_TYPE.SINGLE.TYPE || this._model._itemType == Constant.GROUP_TYPE.OPTION.TYPE){
            html = "";
        }
        //满减
        if(this._model._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            html = `<div class='good_item_head  ${this._model._isChecked ?'active':''} '>
                <span class='item le_tag' gname>${this._model._groupDefaultName}</span>
                <span class='item' gmsg tag="reduceGroupMsg">${this._model._groupMsg}</span> `
            // SHOP-37491 满减作用域为单品时，不展示凑单入口
            if(!this._model._singleFull){
                html += `<a href="javascript:;" class='item le_color_red' tag="goAddon">
                    <span tag="reduceGroupTag">${this._model._groupTag}</span><i class='iconfont icon-arrow-right le_vertical_align_m'></i>
                </a>`
            }
            html += `</div>`;
        }
        //套餐
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            html = `<div class='good_item_head  ${this._model._isChecked ?'active':''} ' style='${this._model._purchaseMsg == ""?"":"height:60px;"}'>
                <span class='fl' style="position:relative;top:3px;">
                    ${this.getPackageCheckbox()}
                </span>
                <div class='fl package_title'>
                    <span class='item le_tag'>优惠套餐</span>
                    <span class='item' tag='tcName' style="opacity:${(this._model._invalid ) ? '0.5' : '1'};">${this._model._groupName}</span>
                </div>
                <div class='fl le_width_172 i_price'>
                    <p class='le_paddingl_31' style="opacity:${(this._model._invalid ) ? '0.5' : '1'};">¥<span tag='tcPrice'>${this._model._groupPrice}</span></p>
                </div>
                <div class='fl le_width_172 i_quantity'>
                    <p class='le_num_action'>
                    ${this.getPackageCountBtn()}
                    </p>
                    <p class="le_color_red limit_tip" tag='group_purchaseMsg'>${this._model._purchaseMsg}</p>
                </div>
                <div class='fl le_width_172 i_sum'>
                    <p class='le_paddingl_65' style="opacity:${(this._model._invalid ) ? '0.5' : '1'};">¥<span tag='tcTotalPrice'>${this._model._groupTotalPrice}</span></p>
                </div>
                <div class='fl le_width_116 i_action'>
                    <button tag='groupdeletebtn'>删除</button>
                </div>
            </div>`;
        }
        return html;
    }

    interceptPackageList(){
        //name 
        let imgEl = $(this._headerBoxEl).find("[tag=tcName]");
        new Intercept().init(imgEl, this._model, "_groupName");
        //price
        let nameEl = $(this._headerBoxEl).find("[tag=tcPrice]");
        new Intercept().init(nameEl, this._model, "_groupPrice");
        //count
        let addpriceEl = $(this._headerBoxEl).find("[tag=tcCount]");
        new Intercept().init(addpriceEl, this._model, "_groupCount");
        //totalPrice
        let countEl = $(this._headerBoxEl).find("[tag=tcTotalPrice]");
        new Intercept().init(countEl, this._model, "_groupTotalPrice");
        //checked
        let checkedEl = $(this._el).find("[tag=setActive]");
        let checkedIntercept =  new Intercept();
        checkedIntercept.init(checkedEl, this._model, "_isChecked", 'cls',"icon-checked","icon-uncheck");
        // Background
        let backGrounddEl = $(this._mainSkuBoxEl).find("[tag=setGroupBackground]");
        // new Intercept().init(backGrounddEl, this._model, "_isChecked", 'cls',"active");
        checkedIntercept.addObserver(backGrounddEl,'cls',"active");
        // good_item_head_box
        let headBoxEl = $(this._el).find("[tag=group_head_box_background_tag]");
        checkedIntercept.addObserver(headBoxEl,'cls',"active");

        //_purchaseMsg
        let purchaseMsg = $(this._el).find("[tag=group_purchaseMsg]");
        new Intercept().init(purchaseMsg, this._model, "_purchaseMsg");

        //_groupMsg
        let _groupMsgEl = $(this._el).find("[tag=reduceGroupMsg]");
        if(_groupMsgEl){
            new Intercept().init(_groupMsgEl, this._model, "_groupMsg");
        }

        //_groupTag
        let _groupTagEl = $(this._el).find("[tag=reduceGroupTag]");
        if(_groupTagEl){
            new Intercept().init(_groupTagEl, this._model, "_groupTag");
        }
    }

    interceptReduce(){ 
        //_groupMsg
        let _groupMsgEl = $(this._el).find("[tag=reduceGroupMsg]");
        if(_groupMsgEl.length>0){
            new Intercept().init(_groupMsgEl, this._model, "_groupMsg");
        }

        //_groupTag
        let _groupTagEl = $(this._el).find("[tag=reduceGroupTag]");
        if(_groupTagEl.length>0){
            new Intercept().init(_groupTagEl, this._model, "_groupTag");
        }
        
        // good_item_head_box
        let headBoxEl = $(this._el).find("[tag=group_head_box_background_tag]");
        let checkedIntercept =  new Intercept();
        checkedIntercept.init(headBoxEl, this._model, "_isChecked", 'cls',"active");
    }

    render(parentEl){
        let gid = this._model._id;
        let html = "";
        //套餐
        if(this._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
            html = `<div class="good_item good_package" tag='taocan' gid='${gid}'>
                <div class='good_item_content'>
                    <div class='content_item ${this._model._isChecked ?'active':''}' iddf="${this._model._itemId}" tag="setGroupBackground">
                        <!-- Header -->
                        <div class='good_item_head_box  ${this._model._isChecked ?'active':''} taocan' iddf="${this._model._id}" tag="group_head_box_background_tag"></div>
                        <div class='good_main'>
                            <!-- 主品 -->
                            <div class='mainSku'></div>
                            <!-- 主品附属商品 -->
                            <div class='extra extraCls'></div>
                            <!-- 套餐里的其他商品 -->
                            <div class='other packageBox'></div>
                        </div>
                    </div>
                </div>
            </div>`;
            this._el = $(html);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=taocan] .taocan");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=taocan] .mainSku");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.append($(headerHtml));

            //监听套餐model变换，数据挂载在主品上面
            this.interceptPackageList();
        }//满减
        else if(this._model._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            html = `<div class="good_item" tag='notPackage' gid='${gid}'>
                <!-- Header -->
                <div class='good_item_head_box  ${this._model._isChecked ?'active':''} mjHeaderbox' iddf="${this._model._id}" tag="group_head_box_background_tag"></div>
                <!-- 主品 -->
                <div class='good_item_content mjSkuContainer'>
                    <!-- 主品附属商品 
                    <div class='extra extraCls'>
                        <div class='clearfix extra_item service'></div>
                        <div class='clearfix extra_item option'></div>
                        <div class='clearfix extra_item giftbox'></div>
                        <div class='clearfix extra_item custom'></div>
                    </div> -->
                </div>
            </div>`;
            this._el = $(html);
            // $(parentEl).html(this._el);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mjHeaderbox");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mjSkuContainer");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.html($(headerHtml));
            //监听满减model变化
            this.interceptReduce();
        }//选件，单品
        else{
            html = `<div class="good_item testcls" tag='notPackage' gid='${gid}'>
                <!-- Header -->
                <div class='good_item_head_box  ${this._model._isChecked ?'active':''} headerbox' iddf="${this._model._id}" tag="group_head_box_background_tag"></div>
                <div class="good_item_content">
                    <div class='content_item ${this._model._isChecked ?'active':''}' iddf="${this._model._itemId}"  tag="setGroupBackground">
                        <div class="good_main">
                            <!-- 主品 -->
                            <div class='mainSku'></div>
                            <!-- 主品附属商品 -->
                            <div class='extra extraCls'></div>
                        </div>
                    </div>
                </div>
            </div>`;
            this._el = $(html);
            $(parentEl).append(this._el);

            this._headerBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .headerbox");
            this._mainSkuBoxEl = $("div[gid='"+gid+"'][tag=notPackage] .mainSku");

            let headerHtml = this.getHeader();
            headerHtml && this._headerBoxEl.append($(headerHtml));
        }

        this._addEl = $(this._el).find("input[tag='packageadd']");
        this._reduceEl = $(this._el).find("input[tag='packagereduce']");
        this.regEvent();
    }

    regEvent(){
        let that = this;
        //减少数量
        this._el.off("click","input[tag='packagereduce']").on("click","input[tag='packagereduce']",function(){
            let count = parseInt(that._model._groupCount) - 1;
            if (count < that._model.getMaxBuyCount()){
                that._addEl.removeAttr("disabled");
            }
            that._model.modifyCount(count).then(()=>{
                if(count == 1){
                    $(this).attr("disabled",true);
                }
            }).catch(err=>{
                Alert.showTip(err);
            });
        })

        //增加数量
        this._el.off("click","input[tag='packageadd']").on("click","input[tag='packageadd']",function(){
            that._reduceEl.removeAttr("disabled");
            let count = parseInt(that._model._groupCount) + 1;
            that._model.modifyCount(count).then(x=>{
                if (count >= that._model.getMaxBuyCount()) {
                    $(this).attr("disabled", true);
                }
            }).catch(err=>{
                Alert.showTip(err);
            });
        })

        //blur数量
        this._el.off("blur","input[tag='tcCount']").on("blur","input[tag='tcCount']",function(){
            ViewTool.blurModifyCount(this, that._addEl, that._reduceEl, that._model, that._model._groupCount);
        })

        //激活
        this._el.off("click","i[tag='setActive']").on("click","i[tag='setActive']",function(){
            if(that._model._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
                that._model.setActive().then().catch(err=>{
                    Alert.showTip(err);
                });
            }
        })

        //删除
        this._el.off("click","[tag='groupdeletebtn']").on("click","[tag='groupdeletebtn']",function(){
            Alert.showConfirm({
                title:"删除商品？",
                content:"您确定要删除该商品?",
                confirmText:"确定",
                confirm:function(){
                    that._model.removeGroup().then(x=>{
                        //检测购物车是否还有商品
                        _engine._price._view.checkCartEmpty();
                    }).catch(err=>{
                        Alert.showTip(err);
                    })
                },
                cancelText:"关闭",
                cancel:function(){
                    
                }
            })
        })

        // 去凑单
        this._el.off("click","a[tag='goAddon']").on("click","a[tag='goAddon']",function(){
            window.location.href="./active.html?activityId="+that._model._data.item.promotionid+'&tag=1';
         })
 
         // 去预约
         this._el.off("click","a[tag='goBooking']").on("click","a[tag='goBooking']",function(){
             window.location.href=that._model._data.item.url;
          })
    }
    
}